import { ROUTE } from '../utils/types'

const ROUTES: Record<ROUTE, string> = {
  [ROUTE.HOME]: '/',
  [ROUTE.ABOUT]: '/about',
  [ROUTE.NOT_FOUND]: '*'
}

export default ROUTES
